import React from 'react';
import { NotificationContainer } from './styles';
import { BsBell } from "react-icons/bs";
import colors from '../../assets/styles/colors';

const Notifications = () => {
  return (
    <NotificationContainer id="notification">
      <BsBell color={colors.bgSecondary} size={20} id="bell-icon" />
    </NotificationContainer>
  )
}

export default Notifications;
